import { Link } from "@/components/link";
import { ChevronRightCircleIcon, CircleChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FormDataStep1 } from "../../types";
import schema from "./schema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRef } from "react";
import { Form } from "@/components/ui/form";
import Field from "@/components/Field";
import { Input } from "@/components/ui/input";
import SubmitButton from "@/components/SubmitButton";

interface StepProvideEmailProps {
  onSubmit: (values: FormDataStep1) => Promise<void>;
  showSignInLink?: boolean;
  email?: string;
}

export default function StepProvideEmail(props: StepProvideEmailProps) {
  const { t } = useTranslation();
  const initialValues = useRef<FormDataStep1>({
    email: props.email ?? "",
  });

  const form = useForm({
    defaultValues: initialValues.current,
    resolver: yupResolver(schema),
    mode: "all",
  });

  const handleSubmit = async (values: FormDataStep1) => {
    try {
      await props.onSubmit(values);
    } catch (error) {
      const errorCode = error.code;
      switch (errorCode) {
        default:
          form.setError("email", {
            type: "manual",
            message: t("resetPassword.errorMessages.unknownError"),
          });
      }
    }
  };

  // If email is provided, we don't want to allow user to change it
  const isDisabled = !!props.email;

  return (
    <Form {...form}>
      <form className="grid gap-4" onSubmit={form.handleSubmit(handleSubmit)}>
        <Field
          name="email"
          label={t("resetPassword.email")}
          render={({ field }) => (
            <Input {...field} type="email" disabled={isDisabled} />
          )}
        />

        <footer className="flex place-content-between">
          {props.showSignInLink && (
            <Link to="/sign-in" icon={CircleChevronLeft} className="pl-0">
              {t("resetPassword.backButton")}
            </Link>
          )}
          <span className="flex-1" />

          <SubmitButton
            label={t("resetPassword.resetPasswordButton")}
            loadingLabel={t("resetPassword.resettingPasswordButton")}
            icon={<ChevronRightCircleIcon />}
            disabled={false}
          />
        </footer>
      </form>
    </Form>
  );
}
